import { BaseModel } from './BaseInterface';
export const CashAllocationBase: BaseModel[] = [
  {
    key: 'cashEnhanced',
    userInput: 'Cash Enhanced (zero advisory fee)',
    apiValue: 'cashEnhanced',
    dbValue: 'cashEnhanced'
  },
  {
    key: 'marketFocused',
    userInput: 'Market Focused (0.30% fee)',
    apiValue: 'marketFocused',
    dbValue: 'marketFocused'
  }
];
